import { accountIdFormat } from "@redotech/redo-account-id";
import { suppliesDiscountIdFormat } from "@redotech/redo-marketplace-id";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";
import {
  SuppliesDiscountConfigSchema,
  SuppliesDiscountMethodSchema,
  SuppliesDiscountSchema,
} from "./discount";

/**
 * Creates a supplies discount when `id` is omitted, otherwise updates it.
 * `codes` and `merchantAccountIds` each replace their whole set.
 */
export const upsertSuppliesDiscount = unaryRpc({
  name: "upsertSuppliesDiscount" as const,
  input: z.object({
    id: suppliesDiscountIdFormat.schema.optional(),
    method: SuppliesDiscountMethodSchema,
    title: z.string().min(1),
    config: SuppliesDiscountConfigSchema,
    minimumPurchaseAmount: z.number().int().positive().nullable(),
    startsAt: z.date(),
    endsAt: z.date().nullable(),
    oncePerCustomer: z.boolean(),
    firstTimeCustomersOnly: z.boolean(),
    storefrontMessage: z.string().nullable(),
    codes: z.array(z.string().min(1)),
    /** Empty opens the discount to every merchant. */
    merchantAccountIds: z.array(accountIdFormat.schema),
  }),
  output: z.object({ discount: SuppliesDiscountSchema }),
});
